import Component from '~/components/component';

export default class Menu extends Component {
	constructor(...args) {
		super(...args);
		this._initDom();
	}

	_initDom() {
		this.dom.nav = this.dom.component.querySelector('.js-nav');
		this.dom.btnMenu = this.dom.component.querySelector('.js-btn-menu');
	}

	init() {
		this.dom.btnMenu.addEventListener('click', () => {
			this.dom.nav.classList.toggle('open');
		});
	}

	/*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}
